<template>
  <div class="ml-5">
    <h1 class="text-2xl mb-8 page-heading">
      {{ text }}
    </h1>
  </div>
</template>

<script>
export default {
  props: ["text"],
};
</script>
